/* 
  import of DHTMLX Gantt is required.
*/
import { getWeekNumber, getWeekNumberProjectStart } from '@/helpers';

export const ganttScaleUtil = {
  create
}

/**
 * Configure the gantt's date scale with provided scale level
 * @param {*} g     Gantt instance
 * @param {*} level Scale level. Possible value: hour|day|week|month
 */
function create(g, level, weekNumbers, self) {
  g.config.subscales = [];
  g.config.min_column_width = 50;
  g.config.date_scale = '%Y';
  g.config.scale_unit = 'year';
  g.config.skip_off_time = false;

  switch (level) {
    case 'hour':
      g.config.skip_off_time = true;
      g.config.scale_unit = 'day';
      g.config.date_scale = '%d %M %Y';
      g.config.subscales.push({ unit: 'hour', step: 1, date: '%H:%i' });
      break;
    case 'day':
      if (weekNumbers) {
        g.config.scale_unit = 'week';
      } else {
        g.config.scale_unit = 'month';
      }
      g.config.date_scale = '%F %Y'; //'%M %Y';
      g.config.subscales.push({ unit: 'day', step: 1, date: '%D, %M %j' });
      break;
    case 'week': {
      g.config.date_scale = '%F %Y';
      const dateToStr = g.date.date_to_str('%d %M');
      const weekScaleTemplate = function (date) {
        if (weekNumbers) {
          if (self.weekBase === 'calendar_year' || self.markerStartDate == null || self.markerStartDate.trim().length == 0) {
            return `${self.$t('timescale.week')} ${getWeekNumber(date)}`
          }
          else {
            const start = new Date(self.markerStartDate);
            const week = getWeekNumberProjectStart(start, date);
            if (week > 0) {
              return `${self.$t('timescale.week')} ${week}`
            }
            else {
              return '';
            }
          }
        }
        
        return dateToStr(date) //`${dateToStr(date)} - ${dateToStr(endDate)}`;
      };
      g.config.subscales.push({
        unit: 'week',
        step: 1,
        template: weekScaleTemplate
      });
      break;
    }
    case 'month':
      g.config.subscales.push({ unit: 'month', step: 1, date: '%M, %Y' });
      break;
  }

  g.templates.date_scale = function(date){
    if (level == 'day' && weekNumbers) {
      if (self.weekBase === 'calendar_year' || self.markerStartDate == null || self.markerStartDate.trim().length == 0) {
        return `${self.$t('timescale.week')} ${getWeekNumber(date)}`
      }
      else {
        const start = new Date(self.markerStartDate);
        const week = getWeekNumberProjectStart(start, date);
        if (week > 0) {
          return `${self.$t('timescale.week')} ${week}`
        }
        else {
          return '';
        }
      }
    }
    return g.date.date_to_str(g.config.date_scale)(date);
  };
}